/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResocontoPastiStudenti } from './resoconto-pasti-studenti';
import { ResocontoPastiDipendenti } from './resoconto-pasti-dipendenti';


export interface ServizioMensaPastiDaPreparareDTO { 
    totali_dipendenti?: ResocontoPastiDipendenti;
    scuole_dipendenti?: Array<ResocontoPastiDipendenti>;
    totali_studenti?: Array<ResocontoPastiStudenti>;
    scuole_studenti?: Array<ResocontoPastiStudenti>;
}

